import { useEffect, useState } from 'react';

import { getRecipientAddressesApi } from 'api/order';

const useRecipientAddresses = ({ orderId, enabled }) => {
  const [addresses, setAddresses] = useState([]);
  // Starts true whenever a fetch is going to happen. Left at false, the first render paints an
  // empty dropdown before the effect runs, so the field reads as "this patient has no addresses"
  // for a frame rather than as loading.
  const [loading, setLoading] = useState(Boolean(enabled && orderId));
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!enabled || !orderId) {
      setLoading(false);

      return undefined;
    }

    let active = true;
    setLoading(true);

    getRecipientAddressesApi({ orderIds: [orderId] })
      .then((recipients) => {
        if (!active) return;
        setAddresses(recipients?.[0]?.addresses ?? []);
      })
      .catch(() => {
        if (active) setAddresses([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [orderId, enabled, reloadToken]);

  return { addresses, loading, reload: () => setReloadToken((token) => token + 1) };
};

export default useRecipientAddresses;
